export enum OrderStatusEnum {
    PENDING_NEW_RISK = 10, // 10 - Nova ordem, pendente Risco 
    PENDING_NEW_TRADE_CONECTOR, // 11 - Nova ordem, pendente TradeConector
    PENDING_REPLACE_RISK, // 12 - Edição de ordem, pendente Risco
    PENDING_REPLACE_TRADE_CONECTOR, // 13 - Edição de ordem, pendente TradeConector
    PENDING_CANCEL_RISK, // 14 - Cancelamento de ordem, pendente Risco
    PENDING_CANCEL_TRADE_CONECTOR, // 15 - Cancelamento de ordem, pendente TradeConector
    PENDING_NEW_EXCHANGE, // 16 - Nova ordem, pendente exchange
    PENDING_REPLACE_EXCHANGE, // 17 - Edição de ordem, pendente exchange
    PENDING_CANCEL_EXCHANGE, // 18 - Cancelamento de ordem, pendente exchange
    PENDING_TRIGGER, // 19 - ??
    NEW = 48, // 48 - Nova ordem (enviado para bolsa)
    PARTIALLYFILLED, // 49 - Parcialmente executada
    FILLED, // 50 - Executado
    CANCELED = 52, // 52 - Cancelada
    REPLACED, // 53 - Editada
    REJECTED = 56, // 56 - Rejeitada
    SUSPENDED, // 57 - Suspensa
    EXPIRED = 67, // 67 - Expirada
    PREVIOUSFINALSTATE = 90, // 90 - ??
    CANCELEDBYEVENT = 96, // 96 - Cancelada por evento
    SCHEDULEDREPLACEMENT, // 97 - Agendada para edição 
    SCHEDULEDCANCELATION, // 98 - Agendada para cancelamento
    SCHEDULEDNEW // 99 - Agendada para criação
}

/**

Aberta:
Nova = NEW
Parcialmente executada = PARTIALLY_FILLED 
Editada = REPLACED
Cancelamento pendente = PENDING_CANCEL_EXCHANGE, PENDING_CANCEL_RISK, PENDING_CANCEL_TRADE_CONECTOR
Suspendida = SUSPENDED

Pendente = PENDING_CANCEL_EXCHANGE, PENDING_CANCEL_RISK, PENDING_CANCEL_TRADE_CONECTOR, PENDING_NEW_EXCHANGE, eStatus.PENDING_NEW_RISK, PENDING_NEW_TRADE_CONECTOR, PENDING_REPLACE_EXCHANGE, PENDING_REPLACE_RISK, PENDING_REPLACE_TRADE_CONECTOR, PENDING_TRIGGER

Esperando edição = São todos os Status possíveis de edição:  SCHEDULEDREPLACEMENT,  SCHEDULEDCANCELATION,  SCHEDULEDNEW, 

Fechada:
Totalmente executada = FILLED
Parcialmente executada = PARTIALLY_FILLED

Cancelada:
Você cancelou = CANCELED
Rejeitada = REJECTED
Expirada = EXPIRED

*/